module.exports = {"en-US":{"errors":{"invalid":"it is invalid","missing":"cannot be blank","taken":"already in use"}}}